import MaintenanceNotificationProvider from '../providers/MaintenanceNotificationProvider'

class MaintenanceNotification {
  constructor () {
    this.currentMaintenanceNotification = ''
  }

  startMaintenanceNotificationMonitoring (callback) {
    setInterval(() => {
      this.getActiveMaintenanceNotification(callback)
    }, 49297) // set it to 49+ seconds, instead of 30. Fast enough, set it on a prime number to interfere less with other timed queries.
    this.getActiveMaintenanceNotification(callback)
  }

  getActiveMaintenanceNotification (callback) {
    MaintenanceNotificationProvider.GetActiveMaintenanceNotification().then((result) => {
      if (this.currentMaintenanceNotification !== result) {
        this.currentMaintenanceNotification = result
        if (result !== '[NO MESSAGE]') {
          let translationLabel = ''
          switch (result) {
            case 'SLOW':
              translationLabel = 'maintenance.notification.slow'
              break
            case 'NO DATA':
              translationLabel = 'maintenance.notification.nodata'
              break
            case 'OUT OF ORDER':
              translationLabel = 'maintenance.notification.outoforder'
              break
            case 'CUSTOM':
              translationLabel = 'maintenance.notification.custom'
              break
            default:
              translationLabel = result
              break
          }
          callback(translationLabel)
        }
      }
    })
  }
}

export const MaintenanceNotificationSingle = new MaintenanceNotification()



// WEBPACK FOOTER //
// ./src/services/MaintenanceNotificationService.js